import styled from "styled-components";
import { color, fontSize } from "styled-system";
import { MicroInteractionStyles } from "styles";

export const SVGIcon = styled.svg`
  ${color};
  ${fontSize};
  ${MicroInteractionStyles};
`;
